<template>
    <a href @click.prevent="onClick" class="kid-mode">
        <div class="kid-small-text">Browsing as {{ activeChild.first_name }} in Kid Mode</div>
        <div class="kid-big-text">Exit Kid Mode <span class="fa fa-times"></span></div>
    </a>
</template>

<script>

import { mapState } from 'vuex';
import _ from 'underscore';
import ChildMixin from '@/mixins/ChildMixin';

export default {

    mixins: [ ChildMixin ],

    computed: {
        activeChild() {
            return _.findWhere(this.children, { id: this.activeChildId }) || {};
        },

        ...mapState({
            children: state => state.children,
            activeChildId: state => state.activeChildId,
        }),
    },

    methods: {

        onClick() {
            this.$root.$emit('exit-kid-mode');
        }
    }

}

</script>



// WEBPACK FOOTER //
// resources/js/components/layouts/ExitKidModeSelector.vue